import { render } from "./EditNext.vue?vue&type=template&id=0fb34a9d"
import script from "./EditNext.vue?vue&type=script&lang=js"
export * from "./EditNext.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__